<template>
  <div>
    <title>核销记录</title>
    <section class="mainPart">
      <!--S 公用头部切换-->
      <!-- <CompanyTab :active="currentTit"></CompanyTab> -->
      <!--E 公用头部切换-->
      <!--S 检索-->      
      <el-form :inline="true" :model="distributeForm" class="searchForm">
          <el-form-item label="关键词">
              <el-input clearable v-model="distributeForm.keyword" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="核销时间">
              <el-date-picker v-model="distributeForm.time" type="daterange" align="right"
              unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions" format="yyyy - MM - dd" value-format="yyyy-MM-dd"  >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="getWriteoffRecords">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" plain @click="getWriteoffRecordsExporturl" v-if="payRecordList.length > 0">导出</el-button>
          </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <el-table class="comTable orderTable" ref="gsTable" :data="payRecordList" border :maxHeight="tableHeight" v-loading="isLoad">
        <el-table-column label="序号" type="index" fixed></el-table-column>
        <el-table-column label="订单号" sortable prop="orderno" min-width="230">
          <template slot-scope="scope">
            <span class="textFl" :title="scope.row.orderno">{{scope.row.orderno}}</span>
          </template>
        </el-table-column>
        <el-table-column label="核销时间" min-width="160" sortable prop="submitdate">
          <template slot-scope="scope">
            <span>{{dateTime(scope.row.submitdate,1)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="微门店名称" min-width="150">
          <template slot-scope="scope">
            <span class="textFl" :title="scope.row.corderuname">{{scope.row.corderuname}}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单内容" min-width="220">
          <template slot-scope="scope">
            <span class="textFl" :title="scope.row.ordercontent">{{scope.row.ordercontent}}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单总金额(￥)" min-width="150" sortable prop="allamount">
          <template slot-scope="scope">
            <span class="priceFont">{{scope.row.allamount | formatAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="买家备注"  min-width="150">
          <template slot-scope="scope">
            <span class="textFl" :title="scope.row.buyermemo">{{scope.row.buyermemo || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" prop="opearte">
            <template slot-scope="scope">
              <p class="handle">
                  <span class="detailA" title="详情" @click="details(scope.row.orderno)"><i class="icondetails"></i></span>
                </p>
            </template>
        </el-table-column>
        <template slot="empty" v-if="isLoad">
            <div :class="{noData:isLoad}"></div>
        </template>
        <template slot="empty" v-else>
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <!-- E 列表 -->
      <section class="flexBet">
        <div class="total flexUpDownCenter">
          <b>汇总：</b>
          <p>
            <span>共<b class="redColor priceFont">{{pagebean.totalnum}}</b>个订单</span>
            <span>总金额（￥）：<b class="redColor priceFont">{{allamountSum | formatAmount}}</b></span>
          </p>
        </div>
        <!-- S 分页 -->
        <Page :pageTotal="pagebean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
        <!-- E 分页 -->
      </section>
    </section>
    <!--S 订单详情组件-->
    <OrderDetail :orderDetailBox="orderDetailShow" @closeODBox="orderDetailShow = false" :writeOff="true"></OrderDetail>
    <!--E 订单详情组件-->
    <!--S 订单详情组件-->
    <OrderDetail :orderno="ordernochild" :orderDetailBox="orderDetailShow" @closeODBox="closeodbox"></OrderDetail>
    <!--E 订单详情组件-->
  </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'CompanyStore',
  data () {
    return {
      isLoad:false,//加载中
      currentTit:2, //当前选中菜单
      //检索
      distributeForm: {
        keyword: "", //关键词
        time:"",//核销时间
      },
      payRecordList:[
        {
            status:'启用'
        },{
            status:'禁用'
        },{
            status:'启用'
        }
      ],
      tableHeight: window.innerHeight*.8, //表格动态高度
      orderDetailShow:false, //订单详情
      ordernochild:'',//订单编号
      pickerOptions: {
        shortcuts: [
          {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebean: {
          totalnum: 0,
      }, // 获取到的列表分页信息
      allamountSum: 0, // 核销总金额
    }
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
    OrderDetail: resolve => require(["@/components/common/OrderDetail.vue"], resolve), //查看订单详情组件
  },
  methods: {
    // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getWriteoffRecords();
    },
    // 获取列表信息
    getWriteoffRecords(){
      let params = {
        keyword:this.distributeForm.keyword,
        stime:this.distributeForm.time&&this.distributeForm.time[0]?this.dateTime(this.distributeForm.time[0]) : '',
        etime:this.distributeForm.time&&this.distributeForm.time[1]?this.dateTime(this.distributeForm.time[1]) : '',
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        } 
      }
      this.isLoad = true;
      api.GET_WRITEOFFRECORDS(params).then((res) => {
        if(res.data.status == '200'){
          this.isLoad = false;
          this.payRecordList = res.data.data;
          this.allamountSum = res.data.allamountSum;
          if(res.data.pagebean){
            this.pagebean = res.data.pagebean
          }
        }
      })
    },
    // 导出表格
    getWriteoffRecordsExporturl() {
      let params = {
        keyword:this.distributeForm.keyword,
        stime:this.distributeForm.time&&this.distributeForm.time[0]?this.dateTime(this.distributeForm.time[0]) : '',
        etime:this.distributeForm.time&&this.distributeForm.time[1]?this.dateTime(this.distributeForm.time[1]) : '',
      }
      api.GET_WRITEOFFRECORDSEXPORTURL(params).then((res) => {
        if(res.data.status == '200'){
          this.$message.success('导出成功！');
          window.location.href = res.data.data
        }else{
          this.$message.error(res.data.message);
        }
      })
      
    },
    // 打开订单详情弹框
    details(orderno){
      this.ordernochild = orderno;
      this.orderDetailShow = true;
    },
    // 关闭订单详情
    closeodbox(){
      this.orderDetailShow = false
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200);
    this.getWriteoffRecords();//获取列表信息
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import '../Css/style.css';
.mainPart {padding: 20px; height: calc(100% - 50px);}
/*列表*/
.searchForm>>>.el-range-editor.el-input__inner{width:300px;}
/* 汇总样式zys 2023/02/14 */
.total {margin:20px 10px 0;position: relative;line-height: 21px;}
.total span{margin-right:10px;white-space: nowrap;}
.total > b{font-weight: bold; color: #000;align-self: flex-start;}
.total p{flex: 1;margin-left: 10px;}
</style>




// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/WriteOffRecord.vue